import { TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const ModalTableCells = ({styles, mykey, row}) => {
  return (
    <TableRow style={{ height: '5px' }} key={mykey}>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 0,
          width: '70px',
        }}
        align="center"
      >
        {moment(row.expiry).format('DD-MMM-YY')}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 0,
          width: '20px',
        }}
        align="center"
      >
        {parseFloat(row.strike).toFixed(2)}
      </TableCell>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 0,
        }}
        align="center"
      >
        {row.put_call}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 0,
          width: '32px',
        }}
        align="center"
      >
        {parseFloat(row.theo_bid).toFixed(2)}
      </TableCell>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 0,
          width: '32px',
        }}
        align="center"
      >
        {parseFloat(row.theo_ask).toFixed(2)}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: '0 5px',
          backgroundColor: 'rgb(194, 237, 188)',
          textAlign: 'end',
        }}
        align="end"
      >
        {row.volValue.toFixed(2)}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: '0 5px',
          backgroundColor: '#F5F5F5',
          textAlign: 'end',
        }}
        align="end"
      >
        {row.volume.toLocaleString()}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: '0 5px',
          backgroundColor: '#F5F5F5',
          textAlign: 'end',
        }}
        align="right"
      >
        {row.open_int.toLocaleString()}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: '0 5px',
          textAlign: 'end',
        }}
        align="right"
      >
        {Math.round((row.ivol * 1000) / 10).toFixed(1)}%
      </TableCell>

      <TableCell
        style={
          row.ivol_chg > 0
            ? {
                ...styles.modalTableRow,
                padding: '0 5px',
                color: 'green',
                textAlign: 'end',
              }
            : {
                ...styles.modalTableRow,
                padding: '0 5px',
                textAlign: 'end',
                color: 'red',
              }
        }
        align="right"
      >
        {Math.round((row.ivol_chg * 1000) / 10).toFixed(1)}%
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: '0 5px',
          textAlign: 'end',
        }}
        align="right"
      >
        {
          Math.round((row.itm_prob * 1000) / 10) + '%'
        }
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: '0 5px',
          textAlign: 'end',
          backgroundColor: 'rgb(252, 255, 204)',
        }}
        align="right"
      >
        {
          row.RRS.toFixed(2)
        }
      </TableCell>
    </TableRow>
  );
};
export default ModalTableCells;



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/components/ModalTableCells.jsx